export default {
  namespaced: true,
  service_orders: {
    title: "Ordenes de servicio",
    reference_number: "Numero de referencia",
    company: "Empresa",
    facility: "Instalacion",
    attention_date: "Fecha de atencion",
    date_filters: "Filtros de fecha",
    status:"Estado",
    status_change_date:"fecha de cambio de estado",
    delete_selection:"borrar selección",
    required_fields_to_filter_by_date:"Campos obligatorios para filtrar por fecha",
    pending:"Pendiente",
    in_review:"En revision",
    in_progress:"En proceso",
    finished:"Finalizado",
    canceled:"Cancelado",
    show_maintenance_form: 'Mostrar formulario de mantenimiento'
  },
};
